// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */

/* profile top right links for edit / change password */
#account .profileManagment {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding-top: 3.5rem;
  padding-bottom: 1rem;
}
#account .profileManagment a {
  color: black;
  padding-right: 3rem;
  padding-top: 11px;
}
#account .profileManagment a:last-child {
  padding-left: 3rem;
}

/* Profile info left column */
#account .profileInfo .profileInfoLeftColumn {
  width: 35%;
  padding-left: 2.5rem;
  padding-top: 3rem;
  border-right: 4px solid white;
  float: left;
  height: 34rem;
  background-color: #b9b7b8;
  font-family: 'Rockwell', 'Verdana', sans-serif;
}
#account .profileInfo .profileInfoLeftColumn > * {
  /* All elements in left column always vertical */
  display: block;
}

#account .profileInfo .profileInfoLeftColumn h3 {
  font-size: 30px;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0;
}

#account .profileInfo .profileInfoLeftColumn h4 {
  margin-top: 0;
  font-size: 26px;
}

#account .profileInfo .profileInfoLeftColumn .email {
  font-size: 22px;
}

/* Profile info right column */
#account .profileInfo .profileInfoRightColumn {
  background-color: #e5e5e5;
  float: right;
  width: 65%;
  height: 34rem;
  padding-top: 2rem;
  padding-left: 3rem;
}
#account .profileInfo .profileInfoRightColumn > * {
  /* All elements in left column always vertical */
  display: block;
}

/* Profile info Right column layout */
#account .profileInfo .profileInfoRightColumn .profileInfoLine {
  display: flex;
  justify-content: flex-start;
  padding-left: 1.5rem;
  padding-top: 0.7rem;
  font-size: 22px;
}

/* Profile info Right column styling */
#account .profileInfo .profileInfoRightColumn .profileInfoLine label {
  font-family: 'Rockwell', 'Verdana', sans-serif;
  font-weight: normal;
  width: 17rem;
}

#account .profileInfo .profileInfoRightColumn .profileInfoLine span {
  /* Prevent overflow of text */
  font-family: 'Verdana', sans-serif;
  width: 65%;
  padding-top: 0.25rem;
  font-size: 18px;
}

#account .pwdChgHdr {
  display: flex;
  background-color: #e5e5e5;
  width: 100%;
  padding-bottom: 1.5rem;
}

/* Password change header left column */
#account .pwdChgHdr .pwdChgHdrLeftColumn {
  width: 50%;
  padding-left: 2.5rem;
}
#account .pwdChgHdr .pwdChgHdrLeftColumn h3 {
  font-family: 'Rockwell', 'Verdana', sans-serif;
  font-size: 26px;
  margin-bottom: 0;
}
#account .pwdChgHdr .pwdChgHdrLeftColumn h4 {
  font-family: 'Verdana', sans-serif;
  font-weight: bold;
  font-size: 20px;
  margin-top: 0.5rem;
}

/* Password change / edit profile */
#account .pwdChgHdr .pwdChgHdrRightColumn {
  margin: auto;
  width: 50%;
  text-align: right;
  padding-right: 1.5rem;
  margin-top: 2.5rem;
}

#account .pwdChgFlds {
  display: flex;
  padding-left: 1rem; /* awful. this is indenting the password
    * change fields by 1rem + 15px for the parent bootstrap row element */
  padding-top: 2rem;
  background-color: #f9f9f9;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e5e5e5;
}

/* Edit profile headers on left & right columns */
#account .pwdChgFlds h4 {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 1.5rem;
}

/* Edit profile left column */
#account .pwdChgFlds label {
  font-weight: normal;
}

#account .profileHolder {
  border-bottom: 2px solid #e5e5e5;
}

/* The little arrow at the end of the select box */
#account .profileHolder .profileFieldSelectContainer {
  position: relative;
}

#account .profileHolder .profileFieldSelectContainer select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

#account .profileHolder .profileFieldSelectContainer select::-ms-expand {
  display: none;
}

#account .profileHolder .profileFieldSelectContainer .downArrow {
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid black;
  pointer-events: none;
  height: 2.7rem;
  margin-top: 4px;
}

#account .profileHolder .profileFieldSelectContainer img {
  width: 25px;
  height: 25px;
  margin-top: 6px;
  margin-right: 8px;
  margin-left: 7px;
}

/* Divide the city, state and postal code into 3 side by side boxes */
#account .addrCityStatePostalCode {
  display: flex;
  justify-content: space-between;
}
#account .addrCityStatePostalCode div {
  width: 32%;
}

/* Edit profile right column */
#account .pwdChgFldsRightColumn {
  padding-left: 1.5rem;
}

/* top/bottom margin between each input file in edit profile 
 * and change password */
#account .profileHolder input,
#account .profileHolder select {
  margin-bottom: 15px;
}

/* Legacy password stuff */
#account .passwordHolder input {
  border: 1px solid #000;
  margin-bottom: 15px;
}

#account .passwordHolder a,
#account .profileHolder a {
  margin-right: 3rem;
}

#account .passwordHolder button {
  width: 146px;
  border-radius: 13px;
  padding: 10px 8px;
  border: 2px solid white;
  margin-right: 2.5rem;
}

#account .profileHolder button {
  width: 150px;
  border: 2px solid #fff;
  padding: 10px 45px;
  margin-right: 2.5rem;
}

#account #stateSelector {
  width: 100%;
}

#account .summaryBox {
  width: 26rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: white;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#account .summaryBoxContent {
  width: 26rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: white;
  border: 1px solid black;
  padding-left: 1rem;
}

#account .summaryBox .amount {
  font-weight: bold;
  font-size: 32px;
  text-align: center;
}

#account .summaryBox .title {
  font-size: 14px;
}

#account .teal {
  border-color: #00a599;
  color: #00a599;
}

#account .purple {
  border-color: #80379b;
  color: #80379b;
}

#account .green {
  border-color: #92d400;
  color: #00a599;
}

#account .orange {
  border-color: #e87722;
  color: #e87722;
}

#account .yella {
  border-color: #ebb700;
  color: #ebb700;
}

#account .baiBlue {
  border-color: #00a1de;
  color: #00a1de;
}

#account .completionsGroup {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  float: right;
  margin-right: 20px;
}

#account .completionsGroup .summaryBox {
  margin-bottom: 20px;
}

#account .spinnerLoading .spinner {
  margin: 0px !important;
  height: 20px !important;
  width: auto !important;
  text-align: left !important;
}

#account .orange .spinner > div {
  background-color: #e87722 !important;
}

#account .purple .spinner > div {
  background-color: #80379b !important;
}

#account .teal .spinner > div {
  background-color: #00a599 !important;
}

#account .baiBlue .spinner > div {
  background-color: #00a1de !important;
}

.row.achievementsGroup {
  justify-content: space-around;
  display: flex;
  padding-top: 20px;
  padding-bottom: 20px;
}

#account .badgesEarned {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  padding-bottom: 15px;
  padding-top: 5px;
}

#account .badgeDisplayed {
  padding-bottom: 15px;
  padding-left: 0px;
  padding-right: 0px;
}

#account .badgeDisplayed img {
  height: 100px;
  margin-bottom: 5px;
}

#account .badgeDisplayed div {
  width: 100%;
}

#account .display-flex {
  display: flex;
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/account.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX,uDAAuD;AACvD;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB,EAAE;yEACmD;EACvE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;AACtB;;AAEA;wBACwB;AACxB;;EAEE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":["/* header */\n\n/* profile top right links for edit / change password */\n#account .profileManagment {\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: row;\n  padding-top: 3.5rem;\n  padding-bottom: 1rem;\n}\n#account .profileManagment a {\n  color: black;\n  padding-right: 3rem;\n  padding-top: 11px;\n}\n#account .profileManagment a:last-child {\n  padding-left: 3rem;\n}\n\n/* Profile info left column */\n#account .profileInfo .profileInfoLeftColumn {\n  width: 35%;\n  padding-left: 2.5rem;\n  padding-top: 3rem;\n  border-right: 4px solid white;\n  float: left;\n  height: 34rem;\n  background-color: #b9b7b8;\n  font-family: 'Rockwell', 'Verdana', sans-serif;\n}\n#account .profileInfo .profileInfoLeftColumn > * {\n  /* All elements in left column always vertical */\n  display: block;\n}\n\n#account .profileInfo .profileInfoLeftColumn h3 {\n  font-size: 30px;\n  font-weight: bold;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n#account .profileInfo .profileInfoLeftColumn h4 {\n  margin-top: 0;\n  font-size: 26px;\n}\n\n#account .profileInfo .profileInfoLeftColumn .email {\n  font-size: 22px;\n}\n\n/* Profile info right column */\n#account .profileInfo .profileInfoRightColumn {\n  background-color: #e5e5e5;\n  float: right;\n  width: 65%;\n  height: 34rem;\n  padding-top: 2rem;\n  padding-left: 3rem;\n}\n#account .profileInfo .profileInfoRightColumn > * {\n  /* All elements in left column always vertical */\n  display: block;\n}\n\n/* Profile info Right column layout */\n#account .profileInfo .profileInfoRightColumn .profileInfoLine {\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 1.5rem;\n  padding-top: 0.7rem;\n  font-size: 22px;\n}\n\n/* Profile info Right column styling */\n#account .profileInfo .profileInfoRightColumn .profileInfoLine label {\n  font-family: 'Rockwell', 'Verdana', sans-serif;\n  font-weight: normal;\n  width: 17rem;\n}\n\n#account .profileInfo .profileInfoRightColumn .profileInfoLine span {\n  /* Prevent overflow of text */\n  font-family: 'Verdana', sans-serif;\n  width: 65%;\n  padding-top: 0.25rem;\n  font-size: 18px;\n}\n\n#account .pwdChgHdr {\n  display: flex;\n  background-color: #e5e5e5;\n  width: 100%;\n  padding-bottom: 1.5rem;\n}\n\n/* Password change header left column */\n#account .pwdChgHdr .pwdChgHdrLeftColumn {\n  width: 50%;\n  padding-left: 2.5rem;\n}\n#account .pwdChgHdr .pwdChgHdrLeftColumn h3 {\n  font-family: 'Rockwell', 'Verdana', sans-serif;\n  font-size: 26px;\n  margin-bottom: 0;\n}\n#account .pwdChgHdr .pwdChgHdrLeftColumn h4 {\n  font-family: 'Verdana', sans-serif;\n  font-weight: bold;\n  font-size: 20px;\n  margin-top: 0.5rem;\n}\n\n/* Password change / edit profile */\n#account .pwdChgHdr .pwdChgHdrRightColumn {\n  margin: auto;\n  width: 50%;\n  text-align: right;\n  padding-right: 1.5rem;\n  margin-top: 2.5rem;\n}\n\n#account .pwdChgFlds {\n  display: flex;\n  padding-left: 1rem; /* awful. this is indenting the password\n    * change fields by 1rem + 15px for the parent bootstrap row element */\n  padding-top: 2rem;\n  background-color: #f9f9f9;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid #e5e5e5;\n}\n\n/* Edit profile headers on left & right columns */\n#account .pwdChgFlds h4 {\n  font-weight: bold;\n  font-size: 16px;\n  margin-bottom: 1.5rem;\n}\n\n/* Edit profile left column */\n#account .pwdChgFlds label {\n  font-weight: normal;\n}\n\n#account .profileHolder {\n  border-bottom: 2px solid #e5e5e5;\n}\n\n/* The little arrow at the end of the select box */\n#account .profileHolder .profileFieldSelectContainer {\n  position: relative;\n}\n\n#account .profileHolder .profileFieldSelectContainer select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n#account .profileHolder .profileFieldSelectContainer select::-ms-expand {\n  display: none;\n}\n\n#account .profileHolder .profileFieldSelectContainer .downArrow {\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-left: 1px solid black;\n  pointer-events: none;\n  height: 2.7rem;\n  margin-top: 4px;\n}\n\n#account .profileHolder .profileFieldSelectContainer img {\n  width: 25px;\n  height: 25px;\n  margin-top: 6px;\n  margin-right: 8px;\n  margin-left: 7px;\n}\n\n/* Divide the city, state and postal code into 3 side by side boxes */\n#account .addrCityStatePostalCode {\n  display: flex;\n  justify-content: space-between;\n}\n#account .addrCityStatePostalCode div {\n  width: 32%;\n}\n\n/* Edit profile right column */\n#account .pwdChgFldsRightColumn {\n  padding-left: 1.5rem;\n}\n\n/* top/bottom margin between each input file in edit profile \n * and change password */\n#account .profileHolder input,\n#account .profileHolder select {\n  margin-bottom: 15px;\n}\n\n/* Legacy password stuff */\n#account .passwordHolder input {\n  border: 1px solid #000;\n  margin-bottom: 15px;\n}\n\n#account .passwordHolder a,\n#account .profileHolder a {\n  margin-right: 3rem;\n}\n\n#account .passwordHolder button {\n  width: 146px;\n  border-radius: 13px;\n  padding: 10px 8px;\n  border: 2px solid white;\n  margin-right: 2.5rem;\n}\n\n#account .profileHolder button {\n  width: 150px;\n  border: 2px solid #fff;\n  padding: 10px 45px;\n  margin-right: 2.5rem;\n}\n\n#account #stateSelector {\n  width: 100%;\n}\n\n#account .summaryBox {\n  width: 26rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  background-color: white;\n  border: 1px solid black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#account .summaryBoxContent {\n  width: 26rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  background-color: white;\n  border: 1px solid black;\n  padding-left: 1rem;\n}\n\n#account .summaryBox .amount {\n  font-weight: bold;\n  font-size: 32px;\n  text-align: center;\n}\n\n#account .summaryBox .title {\n  font-size: 14px;\n}\n\n#account .teal {\n  border-color: #00a599;\n  color: #00a599;\n}\n\n#account .purple {\n  border-color: #80379b;\n  color: #80379b;\n}\n\n#account .green {\n  border-color: #92d400;\n  color: #00a599;\n}\n\n#account .orange {\n  border-color: #e87722;\n  color: #e87722;\n}\n\n#account .yella {\n  border-color: #ebb700;\n  color: #ebb700;\n}\n\n#account .baiBlue {\n  border-color: #00a1de;\n  color: #00a1de;\n}\n\n#account .completionsGroup {\n  justify-content: center;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  float: right;\n  margin-right: 20px;\n}\n\n#account .completionsGroup .summaryBox {\n  margin-bottom: 20px;\n}\n\n#account .spinnerLoading .spinner {\n  margin: 0px !important;\n  height: 20px !important;\n  width: auto !important;\n  text-align: left !important;\n}\n\n#account .orange .spinner > div {\n  background-color: #e87722 !important;\n}\n\n#account .purple .spinner > div {\n  background-color: #80379b !important;\n}\n\n#account .teal .spinner > div {\n  background-color: #00a599 !important;\n}\n\n#account .baiBlue .spinner > div {\n  background-color: #00a1de !important;\n}\n\n.row.achievementsGroup {\n  justify-content: space-around;\n  display: flex;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n#account .badgesEarned {\n  font-weight: bold;\n  text-align: center;\n  font-size: 14px;\n  padding-bottom: 15px;\n  padding-top: 5px;\n}\n\n#account .badgeDisplayed {\n  padding-bottom: 15px;\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n#account .badgeDisplayed img {\n  height: 100px;\n  margin-bottom: 5px;\n}\n\n#account .badgeDisplayed div {\n  width: 100%;\n}\n\n#account .display-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
